export const SHOPTYPE_NONE = 0;
export const SHOPTYPE_SHOP = 1;
export const SHOPTYPE_ESTHE = 2; 

export const SBTYPE_SPEC = 0;
export const SBTYPE_HIME = 1;

// 店舗の外部ネット予約連携の種別（shop.ctrNet）の bit index
export const CTRNET_STANDARD = 0;
export const CTRNET_HEAVEN = 1;
export const CTRNET_GROW = 2;
